module.exports = "varying vec3 vPos;\nvarying vec2 vUv;\nuniform sampler2D texture;\n\nvoid main () {\n  vec4 tColor = texture2D(texture, vUv);\n\n  gl_FragColor = vec4(tColor.rgb, (tColor.r + tColor.g + tColor.b) * tColor.a * 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/components/Parts/BackgroundImage/shader/simple.frag
// module id = 353
// module chunks = 0